<div class="bringoz-quick-filters-select-panel layout-column"
     appBringozIdGenerator="quickFiltersSelectPanel">

  <!--Search Box-->
  <div class="layout-row padding-10">
    <bz-search-input class="flex"
                     appBringozIdGenerator="quickFiltersSearchInput"
                     [placeholder]="placeholder | translate"
                     [ariaLabel]="placeholder | translate"
                     [value]="queryString()"
                     (valueChange)="onQueryChange($event)">
    </bz-search-input>
  </div>

  @if (isInitialLoading()) {
    <!--Initial Loading State-->
    <div class="flex layout-column layout-align-center-center fade-element-in-only">
      <bz-spinner size="lg" [label]="'Loading' | translate"></bz-spinner>
    </div>
  } @else if (isEmpty()) {
    <!--Empty State-->
    <div class="flex layout-column layout-align-center-center fade-element-in-only">
      <bz-empty-state image="assets/images/empty_state/empty_state_branch.png"
                      [title]="'No Quick Filters Found' | translate">
      </bz-empty-state>
    </div>
  } @else {
    <!--List-->
    <div class="flex layout-column overflow-auto quick-filters-list" (scroll)="onScroll($event)">
      <bz-radio-group name="quickFilter"
                      appBringozIdGenerator="quickFilterOptions"
                      [value]="selectedId"
                      [ariaLabel]="'Quick Filters' | translate"
                      (valueChange)="onSelectId($event)">
        @for (quickFilter of quickFilters(); track quickFilter.id) {
          <bz-radio class="quick-filter-item" [value]="quickFilter.id">{{ quickFilter.name | translate }}</bz-radio>
        }
      </bz-radio-group>
    </div>
  }

  <!--Next Page Loading State-->
  @if (isLoading() && !isInitialLoading()) {
    <div class="layout-row layout-align-center-center padding-5">
      <bz-spinner size="sm" [label]="'Loading' | translate"></bz-spinner>
    </div>
  }

</div>
